module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.15425/images/shopify-authorization-connect.svg"